<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
   <div class="save-panel">
          <button class="btn btn-sm btn-warning btn-icon" @click="updateItem">
               <span class="ti-save"></span>Сохранить
          </button>
    </div>
  </div>
</template>

<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "users",
    cardSetLink: "users",
    item: null,
    fields: [
      {
        col:' col-12 col-md-12',
        key: "phone",
        label: "Номер телефона",
        type: "field",
        textType: "text",
      },
      {
        col:' col-12 col-md-12',
        key: "code",
        label: "Код представителя",
        type: "field",
        textType: "text",
      },
      {
        col:' col-12 col-md-12',
        key: "name",
        label: "Наименование",
        type: "field",
        textType: "text",
      },
 
      {
        col:' col-12',
        key: "role",
        label: "Роль пользователя",
        type: "select",
        modal:'role',
        selectKey: "title",

      },
      {
          col:' col-12 col-md-12',
          key: "user",
          label: "Супервайзер",
          type: "select",
          modal: "user",
          params:{role_code:'supervisor'},
          selectKey: "name",
        },
      {
        col:' col-12 col-md-12',
        key: "is_disabled",
        label: "Заблокированный",
        type: "checkbox",
      },
    ],
  }),

  props: ["id"],
  async created() {
    // this.pushLang();
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(this.cardSetLink, this.item, this.fields);
   
    },
  },
};
</script>
<style>
</style>
